import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

export const AboutApp = styled('section')(() => ({
  position: 'relative',
  width: '100%',
}));

export const Bottom = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  gap: '32px',
  width: '100%',

  [theme.breakpoints.down('lg')]: {
    gap: '24px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '16px',
  },
}));

export const Phone = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  width: '380px',
  overflow: 'hidden',
  margin: '0 auto',

  [theme.breakpoints.down('2xl')]: {
    width: '280px',
  },
}));

export const PhoneImg = styled('img')(() => ({
  width: '100%',
}));

export const Screen = styled(motion.img)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  padding: '13px',
  inset: 0,
  objectPosition: 'center',
  willChange: 'transform, opacity',

  [theme.breakpoints.down('2xl')]: {
    padding: '9px',
  },
}));

export const Cards = styled('div')(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  inset: 0,

  [theme.breakpoints.down('lg')]: {
    position: 'relative',
    inset: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '8px',
  },
}));

export const Card = styled('div')(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  width: '446px',
  borderRadius: '24px',
  padding: '28px',
  cursor: 'pointer',
  backgroundColor: theme.palette.color.global.card,
  transition: 'background-color var(--transition-ease-default)',

  '&:hover': {
    backgroundColor: theme.palette.color.button.secondaryHover,
  },
  '&.active': {
    pointerEvents: 'none',
    backgroundColor: theme.palette.color.button.secondaryHover,
  },
  '&.active .text': {
    color: theme.palette.color.fg.primary,
  },
  '&.active .decor': {
    backgroundColor: theme.palette.color.lightGreen,

    '&::before': {
      backgroundColor: theme.palette.color.green,
    },
  },
  '&:nth-of-type(1)': {
    top: '180px',
    left: '80px',

    [theme.breakpoints.down('2xl')]: {
      top: '116px',
      left: '32px',
    },
    [theme.breakpoints.down('lg')]: {
      top: 'auto',
      left: 'auto',
    },
  },
  '&:nth-of-type(2)': {
    top: '500px',
    left: '80px',

    [theme.breakpoints.down('2xl')]: {
      top: '380px',
      left: '32px',
    },
    [theme.breakpoints.down('lg')]: {
      top: 'auto',
      left: 'auto',
    },
  },
  '&:nth-of-type(3)': {
    top: '100px',
    right: '80px',

    [theme.breakpoints.down('2xl')]: {
      top: '70px',
      right: '32px',
    },
    [theme.breakpoints.down('lg')]: {
      top: 'auto',
      right: 'auto',
    },
  },
  '&:nth-of-type(4)': {
    top: '440px',
    right: '80px',

    [theme.breakpoints.down('2xl')]: {
      top: '320px',
      right: '32px',
    },
    [theme.breakpoints.down('lg')]: {
      top: 'auto',
      right: 'auto',
    },
  },

  [theme.breakpoints.down('2xl')]: {
    gap: '12px',
    width: '400px',
    padding: '24px',
  },
  [theme.breakpoints.down('xl')]: {
    width: '370px',
    padding: '20px',
  },
  [theme.breakpoints.down('lg')]: {
    position: 'relative',
    width: '100%',
    padding: '16px',
  },
}));

export const Decor = styled('span')(({ theme }) => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '28px',
  minWidth: '28px',
  height: '28px',
  borderRadius: '50%',
  verticalAlign: 'middle',
  marginRight: '12px',
  backgroundColor: theme.palette.color.button.floatingDefault,
  transition: 'background-color var(--transition-ease-default)',
  transform: 'translateY(-2px)',

  '&::before': {
    position: 'absolute',
    content: '""',
    width: '12px',
    height: '12px',
    borderRadius: '100%',
    backgroundColor: theme.palette.color.fg.unactive,
    transition: 'background-color var(--transition-ease-default)',
  },
}));

export const Pulse = styled(motion.span)(({ theme }) => ({
  position: 'absolute',
  zIndex: -1,
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  backgroundColor: theme.palette.color.green,
  pointerEvents: 'none',
  willChange: 'transform, opacity',
}));

export const Title = styled(Typography)(() => ({
  fontSize: '20px',
}));

export const Text = styled(Typography)(() => ({
  transition: 'color var(--transition-ease-default)',
}));

export const Decors = styled('div')(({ theme }) => ({
  position: 'absolute',
  zIndex: -2,
  top: '50%',
  left: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  pointerEvents: 'none',
  aspectRatio: '1 / 1',
  transform: 'translate(-50%, -50%)',

  [theme.breakpoints.down('md')]: {
    width: '930px',
  },
}));

export const Circle = styled('span')(({ theme }) => ({
  position: 'absolute',
  borderRadius: '100%',
  border: `1px solid ${theme.palette.color.grey.light8}`,

  '&:first-of-type': {
    width: '100%',
    height: '100%',
  },
  '&:last-of-type': {
    width: '59.82%',
    height: '59.82%',

    [theme.breakpoints.down('md')]: {
      width: '560px',
      height: '560px',
    },
  },
}));
